import { cn } from '@/shared/utils/cn';

interface PageHeaderProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  actions?: React.ReactNode;
  rightNode?: React.ReactNode;
  topSlot?: React.ReactNode;
  className?: string;
  rowClassName?: string;
  titleClassName?: string;
  descriptionClassName?: string;
  actionsClassName?: string;
  topSlotClassName?: string;
}

export function PageHeader({
  title,
  description,
  actions,
  rightNode,
  topSlot,
  className,
  rowClassName,
  titleClassName,
  descriptionClassName,
  actionsClassName,
  topSlotClassName,
}: PageHeaderProps) {
  const resolvedActions = actions ?? rightNode;

  return (
    <div className={cn('border-border bg-background border-b px-8 py-6', className)}>
      {topSlot ? <div className={cn('mb-4', topSlotClassName)}>{topSlot}</div> : null}
      <div className={cn('flex items-center justify-between gap-4', rowClassName)}>
        <div>
          <h1 className={cn('text-foreground mb-1 text-2xl font-bold', titleClassName)}>{title}</h1>
          {description ? (
            <div className={cn('text-muted-foreground text-sm', descriptionClassName)}>
              {description}
            </div>
          ) : null}
        </div>
        {resolvedActions ? (
          <div className={cn('flex items-center gap-3', actionsClassName)}>{resolvedActions}</div>
        ) : null}
      </div>
    </div>
  );
}
